import React from 'react'
import styled from 'styled-components'
import { PowerBtn } from '../components/AllSvgs'
import { NavLink } from 'react-router-dom'

const Power = styled.button`
  position: fixed;
  top: 2rem;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: #FCF6F4;
  padding: 0.3rem;
  border-radius: 50%;
  border: 1px solid #000;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
  cursor: pointer;

  /* Fix for blurry button during scroll */
  will-change: transform;
  backface-visibility: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transform-style: preserve-3d;
  perspective: 1000px;

  /* Prevent text selection and improve focus handling */
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  outline: none;
  -webkit-tap-highlight-color: transparent;

  /* Improved hover effect */
  transition: all 0.3s ease;

  /* Hover effects for desktop */
  @media (hover: hover) {
    &:hover {
      background-color: ${props => props.theme === 'dark' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.8)'};
      box-shadow: 0 0 8px 6px ${props => props.theme === 'dark' ? 'rgba(255, 255, 255, 0.4)' : 'rgba(255, 255, 255, 0.4)'};
      transform: translate(-50%, 0) scale(1.1);
    }
  }
  
  /* Touch effects for mobile */
  @media (hover: none) {
    &:active {
      background-color: ${props => props.theme === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(255, 255, 255, 0.6)'};
      box-shadow: 0 0 4px 3px ${props => props.theme === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.3)'};
      transform: translate(-50%, 0) scale(1.05);
      transition: all 0.1s ease;
    }
  }

  &:focus {
    outline: none;
  }

  & > *:first-child {
    text-decoration: none;
    color: inherit;
    /* Prevent text selection on the link */
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  @media (max-width: 768px) {
    top: 1rem;
    width: 2.2rem;
    height: 2.2rem;
  }

  @media (max-width: 480px) {
    top: 0.8rem;
    width: 2rem;
    height: 2rem;
    padding: 0.2rem;
  }
`

const PowerButton = ({ onToggle, isIntroPage = false, theme = 'light' }) => {
  const getIconSize = () => {
    if (window.innerWidth <= 480) return 25;
    if (window.innerWidth <= 768) return 28;
    return 30;
  };
  
  const [iconSize, setIconSize] = React.useState(getIconSize());
  
  React.useEffect(() => {
    const handleResize = () => {
      setIconSize(getIconSize());
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle click based on context
  const handleClick = (e) => {
    if (isIntroPage && onToggle) {
      e.preventDefault();
      onToggle();
    }
  };

  return (
    <Power onClick={handleClick} theme={theme}>
      <NavLink to="/">
        <PowerBtn width={iconSize} height={iconSize} fill='currentColor'/>
      </NavLink>
    </Power>
  )
}

export default PowerButton
